import React from "react";
import RequestPreview from "../../preview/RequestPreview";
import { isTouch } from "../../../../../utils/screenUtil";
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import Tooltip from "../../../../../common/tooltip/Tooltip";

function Waiting({ title, requests, activeJournalId, setActiveJournalId }) {
  const history = useHistory();

  return (
    <>
      <div className="subtitle">{title}</div>
      {requests &&
        requests.map((request, index) => (
          <RequestPreview
            className={isTouch() && index > 0 ? "mt-6" : ""}
            key={`waiting${index}`}
            {...request}
            blur={activeJournalId && activeJournalId !== request.uid}
            setActiveJournalId={setActiveJournalId}
            renderRequestActions={() => (
              <Tooltip
                content={"Pregled dokumenata na obradi"}
                children={
                  <FontAwesomeIcon
                    className="is-clickable"
                    icon={faFolderOpen}
                    onClick={() => {
                      history.push(
                        `/receivedRequests/${request.id}/submissions/${request.uid}/previewDocuments`,
                        request.statusColor
                      );
                    }}
                    size="2x"
                  />
                }
              ></Tooltip>
            )}
            renderGeneralActions={() => (
              <div className="is-pulled-right" style={{ width: 33, height: 33 }}>
                <CircularProgressbar
                  value={request.progress}
                  text={`${request.progress}%`}
                  styles={buildStyles({
                    // Text size
                    width: "100%",
                  })}
                />
              </div>
            )}
          />
        ))}
    </>
  );
}

export default Waiting;
